import RESTClient from 'web-app/api/clients/rest-client-famly-app';

export const fetchReport = (institutionId, from, splitAt, groupBy, showChildLeaveAsAvailable) => {
    return RESTClient.getAuthenticatedObservable(`v2/occupancy-overview/${institutionId}`, {
        from,
        groupBy,
        showChildLeaveAsAvailable,
        splitAt,
    });
};
